import { render, staticRenderFns } from "./CargueBalance.vue?vue&type=template&id=20cea14f&scoped=true"
import script from "./CargueBalance.vue?vue&type=script&lang=js"
export * from "./CargueBalance.vue?vue&type=script&lang=js"
import style0 from "./CargueBalance.vue?vue&type=style&index=0&id=20cea14f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20cea14f",
  null
  
)

export default component.exports